﻿import moment from "moment";
import Cookies from "js-cookie";
import _ from 'underscore';           // ESM import; Vite handles underscore fine

const maxCharactersToCheck = 200;

const dateLocale = "en-gb";

function isNullOrUndefined(obj) {
	return obj === null || typeof (obj) === 'undefined';
}

function deepClone(object) {
	var clone = _.clone(object);
	_.each(clone, function (value, key) {
		if (_.isObject(value)) {
			clone[key] = deepClone(value);
		}
	});

	return clone;
}

function executeIfNotNull(...args) {
	var method = args.shift();
	if (typeof method == 'function') {
		method(...args);
	}
}

function insertIntoArray(currentArray, insertIndex, item) {
	return [
		...currentArray.slice(0, insertIndex),
		item,
		...currentArray.slice(insertIndex)
	];
}

function sortAlphabetically(arr, sortProperty) {
	return _.sortBy(arr, function (item) {
		return item[sortProperty].toLowerCase();
	});
}

function sortDesc(arr, sortProperty) {
	return arr.sort(function (a, b) { return b[sortProperty] - a[sortProperty] });
}

function sortByDate(arr, sortProperty, dir = "asc") {
	return arr.sort(function (a, b) { 
		
		var thisDate = moment(a[sortProperty]);
		var compareDate = moment(b[sortProperty]);

		const sortAsc = dir === "asc";

		if (!thisDate.isValid() && !compareDate.isValid()) {
			return 0;
		}

		if(thisDate.isValid() && !compareDate.isValid()) {
			return sortAsc ? -1 : 1;
		}

		if(!thisDate.isValid() && compareDate.isValid()) {
			return sortAsc ? 1 : -1;
		}

		if (thisDate.isBefore(compareDate)) {
			return sortAsc ? -1 : 1;
		} else if (thisDate.isAfter(compareDate)) {
			return sortAsc ? 1 : -1;
		}

		return 0;
	});

}

function kebabCase(words) {
	return words.toLowerCase().trim().replace(/ /g, "-").replace(/_/g, "-");
}

function downloadFile(blob, filename) {
	let href = window.URL.createObjectURL(blob);
	let link = document.createElement('a');
	link.href = href;
	link.setAttribute('download', filename); //or any other extension
	document.body.appendChild(link);
	link.click();
}

function findRecursiveItem(structure, itemId, type) {
	var response = null;
	if (structure != null) {
		for (var i = 0; i < structure.length; i++) {
			var currentItem = structure[i];
			if (currentItem.type === type && currentItem.id === itemId) {
				return currentItem;
			}
			if (currentItem.type === "group") {
				var innerResponse = findRecursiveItem(currentItem.items, itemId, type);
				if (innerResponse != null) {
					response = innerResponse;
				}
			}
		}
	}
	return response;
}

function formatDate(date, format) {
	return moment(date).format(format);
}

function deepEqual(obj1, obj2) {
	return _.isEqual(obj1, obj2);
}


function checkForCookie(cookieName) {
	return Cookies.get(cookieName) !== undefined;
}

function setDateToLocal(date, format) {
	if (!date) {
		return "-";
	}

	let utcDate = moment.utc(date);

	if (utcDate.isValid()) {
		return utcDate.locale(dateLocale).format(format);
	} else {
		return "-";
	}
}

function base64StringToFile(base64String, filename, fromFormCanvas = false) {
	let arr = fromFormCanvas ? [base64String] : base64String.split(',');
	let mime = fromFormCanvas ? 'image/jpeg' : 'application/octet-stream';

	if (!fromFormCanvas) {
		// Limit arr[0] length to prevent ReDoS
		const header = arr[0].slice(0, maxCharactersToCheck); // Only check first 200 chars
		let mimeMatch = header.match(/:([a-zA-Z0-9!#$&^_.+-]{1,50});/);
		mime = mimeMatch ? mimeMatch[1] : mime;
	}

	let bstr = atob(arr[arr.length - 1]);
	let n = bstr.length;
	let u8arr = new Uint8Array(n);

	while(n > 0) {
		n--;
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new File([u8arr], filename, {type: mime});
}

export const HelperFunctions = {
	isNullOrUndefined: isNullOrUndefined,
	executeIfNotNull: executeIfNotNull,
	deepClone: deepClone,
	insertIntoArray: insertIntoArray,
	sortAlphabetically: sortAlphabetically,
	sortDesc: sortDesc,
	sortByDate: sortByDate,
	kebabCase: kebabCase,
	downloadFile: downloadFile,
	findRecursiveItem: findRecursiveItem,
	formatDate: formatDate,
	deepEqual: deepEqual,
	checkForCookie: checkForCookie,
	setDateToLocal: setDateToLocal,
	base64StringToFile: base64StringToFile
};

